export default __webpack_public_path__ + "static/media/réseauter.ee479f06.png";